import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      THANKS_FOR_YOUR_ORDER: "Takk for din bestilling!",
      YOUR_FIRST_DELIVERY_ARRIVES: "Din første levering kommer",
      SEE_YOUR_MENU_AND_CHOOSE_FREELY_BETWEEN_N_DISHES: (n: number) =>
        `Se din meny og velg mellom ${n} retter`,
    },

    se: {
      THANKS_FOR_YOUR_ORDER: "Tack för din beställning!",
      YOUR_FIRST_DELIVERY_ARRIVES: "Din första leverans kommer",
      SEE_YOUR_MENU_AND_CHOOSE_FREELY_BETWEEN_N_DISHES: (n: number) =>
        `Se din meny och välj fritt mellan ${n} rätter`,
    },

    dk: {
      THANKS_FOR_YOUR_ORDER: "Tak for din bestilling",
      YOUR_FIRST_DELIVERY_ARRIVES: "Din første levering kommer",
      SEE_YOUR_MENU_AND_CHOOSE_FREELY_BETWEEN_N_DISHES: (n: number) =>
        `Se din menu og vælg mellem ${n} retter`,
    },
  } as const
)[language];
